import { render, staticRenderFns } from "./CourseCategoryClasses.vue?vue&type=template&id=453b705e&scoped=true"
import script from "./CourseCategoryClasses.vue?vue&type=script&lang=js"
export * from "./CourseCategoryClasses.vue?vue&type=script&lang=js"
import style0 from "./CourseCategoryClasses.vue?vue&type=style&index=0&id=453b705e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453b705e",
  null
  
)

export default component.exports